module.exports = __webpack_public_path__ + "static/media/sad-face-in-rounded-square.61ae586e.svg";